import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography, Box, CircularProgress, Stack, Button } from '@mui/material';
// components
import { useSelector } from 'react-redux';
// sections
import {
  AppTasks,
  AppNewsUpdate,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppWidgetSummary,
  AppCurrentSubject,
  AppConversionRates,
} from '../../sections/@dashboard/app';

import { getHospitalInformation } from '../../api/admin/hospitalInformation';
import HospitalInformationDialog from '../../sections/dialogs/hospitalInformationDialog';
import CustomSnackBar from '../../components/snackbar';

const getColor = ['secondary', 'info', 'warning', 'error']
// ----------------------------------------------------------------------

export default function HospitalInformation() {
  const theme = useTheme();
  const account = useSelector((state) => state.account)

  const [isLoading, setIsLoading] = useState(false)
  const [hospitalInformation, setHospitalInformation] = useState(false)
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState(null)
  const [action, setAction] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const fetchData = async () => {
    setIsLoading(true)
    try {
      const { data } = await getHospitalInformation(account.hospitalAccount._id);
      setHospitalInformation(data.hospitalInformation)
      console.log(data);
      setIsLoading(false)
    }
    catch (e) {
      setIsLoading(false)
      // console.log({ e });
    }
  }

  // Dialog
  const handleDialogOpen = () => {
    setAction(hospitalInformation ? 'EDIT' : 'CREATE')
    setDialogOpen(true);
  };


  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Helmet>
        <title> Service | Teller One </title>
      </Helmet>
      <Box sx={{ height: '100%' }}>
        {!isLoading ?
        <>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Hospital Information
            </Typography>
            <Button variant="contained" onClick={handleDialogOpen}>
              {hospitalInformation? 'Update' : 'Add'} Hospital Information
            </Button>
          </Stack>
        
            <Typography>About us : {hospitalInformation ? hospitalInformation.aboutUs :''}</Typography>
        <Typography>Doctors  : {hospitalInformation ? hospitalInformation.doctorsDirectory :''}</Typography>
        <Typography>Services : {hospitalInformation ? hospitalInformation.servicesAndFacilities :''}</Typography>
        <Typography>Whats New : {hospitalInformation ? hospitalInformation.whatsNew : ''}</Typography>
        <Typography>Website : {hospitalInformation ? hospitalInformation.linkToWebsite : ''}</Typography>
        <Typography>Locaion : {hospitalInformation ? hospitalInformation.location : ''}</Typography>
          
       
          </>
          :
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}><CircularProgress /></Box>}
      </Box>
      <HospitalInformationDialog dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} setSnackbarMessage={setSnackbarMessage} setSnackbarOpen={setSnackbarOpen} setHospitalInformation = {setHospitalInformation} action={action} hospitalInformation = {hospitalInformation}/>
      <CustomSnackBar snackbarOpen={snackbarOpen} setSnackbarOpen={setSnackbarOpen} snackbarMessage={snackbarMessage && snackbarMessage.msg} success={snackbarMessage && snackbarMessage.success} />

    </>
  );
}
